import styled from '@emotion/styled'
import clsx from 'clsx'
import { observer } from 'mobx-react'

import { switchParentChild } from '~/@common/services/parentSession.service'
import { commonRepo } from '~/@common/services/repo.service'
import { typo } from '~/@common/styles'
import { textEllipsis } from '~/@common/styles/textEllipsis'

// 모바일 자녀 선택 바텀시트 — GNB에서 자녀 전환 시 사용
export const ChildSwitchModal = observer(({ onClose }: { onClose: () => void }) => {
  const { childStudents, activeChildStudentId } = commonRepo.parent

  const handleSelect = (studentId: typeof activeChildStudentId) => {
    if (!studentId) return
    switchParentChild(studentId)
    onClose()
  }

  return (
    <S.Container>
      <div className="guide">자녀를 선택해주세요.</div>
      <div className="list">
        {childStudents.map((child) => (
          <button
            key={child.studentId}
            className="item"
            onClick={() => handleSelect(child.studentId)}
          >
            <div className={clsx('radio', child.studentId === activeChildStudentId && 'checked')} />
            <span>{child.name}</span>
          </button>
        ))}
      </div>
    </S.Container>
  )
})

const S = {
  Container: styled.div`
    width: 100%;
    min-width: 300px;
    max-height: 419px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .guide {
      ${typo.caption01}
      color: var(--White);
      background-color: var(--Colors-Gray-800);
      padding: 10px 12px;
      flex-shrink: 0;
    }

    .list {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }

    .item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 20px;
      ${typo.body01}
      color: var(--Colors-Gray-900);
      text-align: left;
      border-bottom: 1px solid var(--Colors-Gray-300);
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      > span {
        min-width: 0;
        flex: 1;
        ${textEllipsis(1)};
      }
    }

    .radio {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid var(--Colors-Gray-400);
      position: relative;

      &.checked {
        border-color: var(--Colors-Blue-500);

        &::after {
          content: '';
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: var(--Colors-Blue-500);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  `,
}
